/* jshint -W024 */
// base script extends default script
import "./default";

import SliderCarousel from "./app/eros/components/common/SliderCarousel.vue";
Vue.component("slider-carousel", SliderCarousel);

Vue.component("shipping-country-select", () => import("./app/eros/components/pageDesign/ShippingCountrySelect.vue"));
Vue.component("basket-preview", () => import("./app/eros/components/basket/BasketPreview.vue"));
Vue.component("basket-totals", () => import("./app/eros/components/basket/BasketTotals.vue"));
Vue.component("coupon", () => import("./app/eros/components/basket/Coupon.vue"));
Vue.component("basket-list", () => import("./app/eros/components/basket/list/BasketList.vue"));
Vue.component("return-country-select", () => import("./app/eros/components/common/ReturnCountrySelect.vue"));
Vue.component("return-label", () => import("./app/eros/components/common/ReturnLabel.vue"));

// =========================
// External Plugins
// =========================
import "./app/eros/plugins/external/svbadge";